<template>
  <div class="sports_result" v-if="u &&  itemDetail" :style="detail.bgstyle">
    <div class="go-back">
      <van-button @click="goBack" size="small" :color="buttonColor"><van-icon name="arrow-left" /> 返回</van-button>
    </div>
    <div class="header" v-if="item_sub_id == 2623">
      <div class="avatar">
        <van-image src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20200509/1589008191-5eb6573faf955.jpg"></van-image>
      </div>
      <div class="info">
        <div class="nickname">
          {{ itemDetail.name }}
        </div>
        <div class="rank">
          <span>排名：第 {{ itemDetail.rank || '-' }} 名</span>
          <span >票数：{{ itemDetail.score }} 票</span>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="avatar">
        <van-image :src="itemDetail.userInfo.avatarurl"></van-image>
      </div>
      <div class="info">
        <div class="nickname">
          {{ itemDetail.name ? itemDetail.name : itemDetail.userInfo.nickname }}
        </div>
        <div class="rank">
          <span>排名：第 {{ itemDetail.rank || '-' }} 名</span>
          <span v-if="item_sub_id==4923 || item_sub_id==4924 || item_sub_id==4934 || item_sub_id==4935 || item_sub_id==4996 || item_sub_id==4997 || item_sub_id==6381 || item_sub_id==6382 || item_sub_id==6383">得分：{{ itemDetail.score }}</span>
          <span v-else>票数：{{ itemDetail.score }} 票</span>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="header">
        <div class="title" :style="detail.bgstyle">{{ item_sub_id == 2623?'步道信息':'选手信息' }}</div>
      </div>

      <div class="body">
        <mVideo :videoUrl="itemDetail.sportsItemSub.animation==1?itemDetail.animationurl:itemDetail.mediaurl" height="3.5rem" :mediaType="itemDetail.sportsItemSub.media_type"></mVideo>
        <template v-if="item_sub_id == 2623">
          <div class="desc">单位：{{itemDetail.registerinfos.mobile}}</div>
          <div class="desc">具体地址：{{itemDetail.registerinfos.address}}</div>
          <div class="desc">简介：{{itemDetail.registerinfos.content}}</div>
        </template>
        <template v-if="item_sub_id == 2624">
          <div class="desc">姓名：{{itemDetail.registerinfos.name}}</div>
          <!-- <div class="desc">手机号码：{{itemDetail.registerinfos.mobile}}</div> -->
          <div class="desc">描述：{{itemDetail.registerinfos.content}}</div>
        </template>
        <template v-if="item_sub_id == 4110">
          <div class="desc">作品名称：{{itemDetail.registerinfos.custom_202888}}</div>
          <!-- <div class="desc">手机号码：{{itemDetail.registerinfos.mobile}}</div> -->
          <div class="desc">作品简介：{{itemDetail.registerinfos.custom_207853}}</div>
        </template>
        <div class="desc">
          我正在参加“{{ itemDetail.sportsItemSub.title }}”。{{item_sub_id==4923 || item_sub_id==4924 || item_sub_id==4934 || item_sub_id==4935 || item_sub_id==4996 || item_sub_id==4997 || item_sub_id==6381 || item_sub_id==6382 || item_sub_id==6383?'':'动动手指，请帮我投一票吧！'}}
          <p style="font-weight: bold;"></p>
          <!-- <p v-if="+itemDetail.myinfo.state">
            系统得分:{{ itemDetail.myinfo.score }}
          </p> -->
        </div>
        <div class="btn-area dd"  v-if="item_sub_id==4923 || item_sub_id==4924 || item_sub_id==4934 || item_sub_id==4935 || item_sub_id==4996 || item_sub_id==4997 || item_sub_id==6381 || item_sub_id==6382 || item_sub_id==6383">
          <van-button round plain :color="detail.bgstyle.background" @click="show = true">分 享</van-button>
        </div>
        <div class="btn-area"  v-else>
          <van-button round plain :color="detail.bgstyle.background" @click="goto">分 享</van-button>
          <van-button round plain @click="vote" :color="detail.bgstyle.background">投 票</van-button>
        </div>
      </div>
    </div>
    <Footbar v-if="item_sub_id != 2623">
      <Cell slot="footbar" v-if="itemDetail && itemDetail.sportsItemSub.register_type == 1">
        <Button
          v-if="itemDetail.today_state !== 1"
          round
          type="primary"
          block
          :color="buttonColor"
          :to="{ name: 'joinSports', params: this.$route.params }"
          >立即参与</Button
        >
        <Button v-else round type="primary" block :color="buttonColor" :to="{ name: 'sportsResult', params: this.$route.params }"
          >参赛详情</Button
        >
      </Cell>
      <Cell slot="footbar" v-else>
        <Button
          v-if="itemDetail.sportsItemSub.register_type == 2"
          round
          type="primary"
          block
          :color="buttonColor"
          :href="itemDetail.sportsItemSub.register_type_value"
          >立即参与</Button
        >
        <Button
          v-if="itemDetail.sportsItemSub.register_type == 3"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="openImg(itemDetail.register_type_value)"
          >立即参与</Button
        >
      </Cell>
    </Footbar>
    <van-overlay z-index="1000" :show="show" @click="show = false">
      <div class="wrapper">
        <img style="width:100%" src="../../../assets/img/common/share.png" />
      </div>
    </van-overlay>
  </div>
  <Empty v-else description="数据加载中" />
</template>

<script>
import mVideo from '@/components/mVideo/index'
import { mapGetters } from 'vuex'
import Footbar from '@/components/footbar/index'
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup, Overlay } from 'vant'

export default {
  computed: {
    buttonColor() {
      let detail = this.detail
      if (!detail) return '#ccc'
      return `${detail.tabstyle[0]['color']}`
    },
    ...mapGetters({
      u: 'getUserInfo',
    }),
  },
  components: {
    Footbar,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    VanImage: Image,
    VanOverlay: Overlay,
    mVideo,
    Popup,
  },
  props: ['item_sub_id', 'sports_id'],
  data() {
    return {
      show: false,
      detail: '',
      itemDetail: '',
      joinList: [],
      certShow: false,
    }
  },
  methods: {
    goto() {
      if(this.itemDetail.sportsItemSub.animation==1) {
        this.$router.push({
          name: 'skeleton',
          params: this.$route.params,
          query: this.$route.query
        })
        } else {
        this.show = true
      }
    },
    goBack() {
      this.$router.push({
        name: 'sportsDetail',
        params: this.$route.params,
      })
    },
    openImg(url) {
      // ...
      wx.previewImage({
        current: '', // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      })
    },
    vote() {
      this.$api.sports
        .vote({
          mcloud_sports_item_user_id: this.$route.query.id,
        })
        .then((r) => {
          if(r.status == 200) {
            this.$toast.success('投票成功')
          }
          this.init()
        })
    },
    init: function() {
      this.$toast.loading({
        duration: 0,
      })
      let params = { cpgid: this.item_sub_id }
      Promise.all([this.$api.sports.sportsMain(this.sports_id), this.$api.sports.getVoteDetail(this.$route.query.id)])
        .then((res) => {
          let { bgstyle, id, tabstyle, introstyle, title } = res[0].data
          try {
            bgstyle = JSON.parse(bgstyle)
            tabstyle = JSON.parse(tabstyle)
            introstyle = JSON.parse(introstyle)
          } catch (e) {
            console.error(e)
          }
          this.detail = { id, bgstyle, tabstyle, introstyle, title }
          // this.joinList = res[1]['list'];
          if (res[1]['data']['registerinfos']) {
            try {
              res[1]['data']['registerinfos'] = JSON.parse(res[1]['data']['registerinfos']);
            } catch (e) {
              console.log(e)
            }
          }
          console.log(res[1]['data'],'111')
          this.itemDetail = res[1]['data']

          this.$toast.clear()
        })
        .then(() => {
          const shareConf = {
            title: ` 我正在参加“${this.itemDetail.sportsItemSub.title}”。动动手指，请帮我投一票吧！`,
            path: '/pages/webview/index?src=' + encodeURIComponent(window.location.href),
          }

          wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) })
        })
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="less" scoped>
.sports_result {
  width: 100vw;
  //height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .go-back {
    width: 100%;
    padding: 0.3rem;
    font-size: 0;
    box-sizing: border-box;
  }
  .wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      width: 100%;
      position: absolute;
      top: 0rem;
    }
  }
  > .header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #fff;
    width: 6.08rem;
    margin: 0.12rem auto 0.24rem;
    border-radius: 0.22rem;
    padding: 0.24rem 0.4rem;
    > .avatar {
      width: 1.04rem;
      height: 1.04rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.48rem;

      > .van-image {
        overflow: hidden;
        width: 1.04rem;
        height: 1.04rem;
        border-radius: 50%;
      }
    }
    > .info {
      > .nickname {
        font-size: 0.28rem;
        line-height: 1.5;
        color: #666;
      }
      .rank {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        color: #666;
        span:first-of-type {
          margin-right: 0.5rem;
        }
      }
    }
  }
  > .body {
    box-shadow: 0px 0.04rem 0.34rem #fa604935;
    width: 6.08rem;
    border-radius: 0.22rem;
    overflow: hidden;
    background: #ffffff;
    > .header {
      width: 100%;
      height: 1.23rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 0.28rem;
        color: #fff;
        background: #4eb4ff;
        width: 2.26rem;
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        border-radius: 0 0.12rem 0 0.12rem;
      }
    }
    > .body {
      padding: 0 0.5rem 0.24rem;
      box-sizing: border-box;
      > .desc {
        padding-top: 0.3rem;
        font-size: 0.28rem;
        color: #4b638a;
      }
      .btn-area {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .van-button {
          width: 48%;
          height: 0.64rem;
          line-height: 0.6rem;
        }
      }
      .dd{
        justify-content: center;
        .van-button {
          width: 90%;
          height: 0.64rem;
          line-height: 0.6rem;
        }
      }
    }
  }
  > .footer {
    margin-top: 0.4rem;
    width: 3.98rem;
    height: 0.76rem;
    > .van-button {
      box-shadow: 0px 0.08rem 0.14rem 0 #fba07a;
    }
  }
}
</style>
